import type { UserRole, AuthenticatedUser } from '@/types/auth';

/**
 * Default landing route per role (Spec S03 §3.2 routing-by-role).
 *
 * Product Owner is a flag on data_analyst_domain_expert (DEC-05), not a
 * standalone role — when set, prefer the skill governance landing.
 */
export function getHomeRoute(user: AuthenticatedUser): string {
  if (user.productOwner) return '/studio/skills';

  const role = user.roles[0];
  return ROLE_HOMES[role as UserRole] ?? '/app/chat';
}

const ROLE_HOMES: Record<UserRole, string> = {
  internal_front_office: '/app/chat',
  data_analyst_standard: '/studio/morning',
  data_analyst_domain_expert: '/studio/morning',
  administrator: '/app/admin/users',
  external_client: '/app/portal/home',
};

/** True if user has any of the required roles. JWT claims are authoritative. */
export function hasAnyRole(user: AuthenticatedUser, required: UserRole[]): boolean {
  return user.roles.some((r) => required.includes(r));
}

export function isExternalClient(user: AuthenticatedUser): boolean {
  return user.roles.includes('external_client');
}

export function isInternalUser(user: AuthenticatedUser): boolean {
  return !isExternalClient(user);
}

export function isAnalyst(user: AuthenticatedUser): boolean {
  return hasAnyRole(user, ['data_analyst_standard', 'data_analyst_domain_expert']);
}
